module.exports = __webpack_public_path__ + "static/payouts_scheme-e982153176a7f861e963ae57db3d2748.svg";